/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {ListItem} from "@deere/ux.uxframe-react";
import "../assets/css/SearchPage.css";
import { useHistory } from 'react-router'
import { CRS_REQUEST_STATUS_OBJ, SCBM_CODE,DEFAULT_LANGUAGE, SCBM_INDIRECT, SURVEY_CODE_MAP_PATH, CRS_SURVEY_TEMPLATES, CRS_SURVEY_TEMPLATE_PATHS } from '../utils/surveyLiterals'
import { getDateFromTimeStamp } from '../utils/utils'
import i18next from 'i18next'
import { getRequestStatusWhenCampaignClosed } from "../utils/utils";

export const AssignmentListItem = ({ item }) => { 
    const history = useHistory();
    function openHomeScreen(e) {
        
        
        let path = ''
        if(item.surveyCode !== SCBM_CODE && item.surveyCode !== SCBM_INDIRECT){            
            i18next.changeLanguage(DEFAULT_LANGUAGE)
        }
        
        switch (item.templateType) {
            case CRS_SURVEY_TEMPLATES.PART:
              path = CRS_SURVEY_TEMPLATE_PATHS.PART;
              break;
            case CRS_SURVEY_TEMPLATES.GENERIC:
              path = CRS_SURVEY_TEMPLATE_PATHS.GENERIC;
              break;
            default:
              if (SURVEY_CODE_MAP_PATH.has(item.surveyCode)) path = SURVEY_CODE_MAP_PATH.get(item.surveyCode);
              else path = SURVEY_CODE_MAP_PATH.get("DEFAULT");
              break;
        }
        
        history.push({
            pathname: `/${path}?rn=${item.id}`,
            state: { surveyType: item.surveyType
                  , updatedByName: item ? item.updatedByName ? item.updatedByName : item.updatedBy : ''
                  , supplierName: `${item.supplierNo} - ${item.supplierName}`
                  , updatedTs: item.updatedts
                  , surveyCode: item.surveyCode
                  , endDate :item.endDate?item.endDate:''
                  , status: item.status
                  , campaign: item }
        })
    };

    function openReviewScreen(e) { 
        e.preventDefault()
        alert('moving to review')
    };

    const isSubmitted = (assignment) => {
        if (!assignment)
            return null
        
        if (assignment.status === CRS_REQUEST_STATUS_OBJ.COMPLETE) {
            return (<><span className="mr-2 font-weight-bold">Submitted by</span>
                    <span>{assignment.updatedByName ? assignment.updatedByName : assignment.updatedBy}</span></>)
        }
        return (<><span className="mr-2 font-weight-bold">Submitted by</span>
            <span>No Submitted</span></>)
    }

    return (
        <ListItem className="list-group-item mb-1">            
                <div className="d-flex w-100 justify-content-between">                    
                    <span>
                        <span className="mr-2 font-weight-bold">Request</span>
                        <span>
                            <a href="" onClick={e => item.type === 'assignment' ? openReviewScreen(e) :  openHomeScreen()}>{item ? item.id + " - " : ''} {item ? item.supplierNo + " - " : ''} {item ? item.supplierName : ''}</a>
                        </span>
                    </span>
                    <span>
                        <span className="mr-2 font-weight-bold">Due date</span>
                        <span>{item ? getDateFromTimeStamp(item.endDate) : ''}</span>
                    </span>
                    <span>
                        <span className="mr-2 font-weight-bold">Status</span>
                        <span>{item ? getRequestStatusWhenCampaignClosed(item.status, item.campaignStatus) : ""}</span>
                    </span>
                </div>
                <div className="d-flex w-100 justify-content-between">
                    <span>
                        <span className="mr-2 font-weight-bold">Type</span>
                        <span>
                            {item ? item.surveyType : ''}
                        </span>
                    </span>
                    <span>
                        <span className="mr-2 font-weight-bold"></span>
                        <span>{isSubmitted(item)}</span>
                    </span>                     
                </div>            
        </ListItem>
    );
};
